var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.batchUnlockMember}},[_vm._v(" "+_vm._s(_vm.$t("team_management.shop.unlock_members"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }